/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const e = {
  arcgisButton: "arcgis-button",
  buttonDisabled: "esri-button--disabled",
  disabled: "esri-disabled",
  empty: "esri-widget__content--empty",
  heading: "esri-widget__heading",
  hidden: "esri-hidden",
  interactive: "esri-interactive",
  loaderAnimation: "esri-widget__loader-animation",
  panel: "esri-widget--panel",
  widget: "esri-widget",
  widgetButton: "esri-widget--button",
  widgetButtonActive: "esri-widget--button-active",
  widgetDisabled: "esri-widget--disabled"
};
export {
  e as g
};
